<template>
  <div id="weeks">
    <v-container fluid>
      <v-flex xs12>
        <HowToUseThisPage />
        <div class="weeks-container">
          <div class="route-container mb-4 section-heading">
            <h1>
              <BookMark :color="iconColor" class="weeks-icon" />
              {{ $t('weeks.missionSupplicationUnits') }}
            </h1>
          </div>
          <div class="mb-7 mt-12">
            <v-btn
              v-if="!openWeeksForm && !editingWeek"
              color="rgba(165, 216, 103, 1)"
              class="elevation-0 font-weight-bold"
              @click="addNewHandler"
              >{{ $t('weeks.createNewWeek') }}</v-btn
            >
            <div v-else class="close-link" @click="closebuilder">
              <v-icon>arrowleft</v-icon>
              <span class="close-link-text">{{ $t('weeks.close') }}</span>
            </div>
          </div>
          <NewWeek
            v-if="openWeeksForm"
            :allCategories="allCategories"
            @closeWeeksForm="closeWeeksFormChild"
          />
          <EditWeek
            v-if="editingWeek"
            :weekbackdoor="weekbackdoor"
            :week="weekToEdit"
            :allCategories="allCategories"
            @closeEditWeeksForm="closeEditWeeksFormChild"
          />
          <v-data-table
            :headers="adminActions"
            fixed-header
            :loading="isloading"
            :loading-text="$t('weeks.loadingWeeks')"
            :no-data-text="$t('weeks.noWeeksCreated')"
            :items="weeks"
            :items-per-page="20"
            :header-props="{ sortIcon: '$sortarrowdown' }"
            :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }"
            class="elevation-1 users-table"
          >
            <template #progress>
              <v-progress-linear
                color="#592892"
                indeterminate
              ></v-progress-linear>
            </template>

            <template #[`item.sections`]="{ item }">
              <div class="action-icons">
                {{ missionsUsingThisWeek(item) }}
              </div>
            </template>

            <template #[`item.title`]="{ item }">
              <div class="d-flex align-center">
                <span class="mr-2">{{ getWeekTitle(item) }}</span>
                <div class="d-flex align-center">
                  <v-chip
                    v-for="lang in getAvailableLanguages(item)"
                    :key="lang.code"
                    size="x-small"
                    :color="getLanguageColor(lang.code)"
                    variant="outlined"
                    class="mr-1"
                  >
                    {{ lang.code.toUpperCase() }}
                  </v-chip>
                </div>
              </div>
            </template>

            <template v-if="isAuthenticated" #[`item.type`]="{ item }">
              <v-chip
                v-if="
                  item.cid == churchid ||
                  checkAuthorization(['superAdmin']).length > 0
                "
                class="px-7"
                :class="[
                  item.verified == 'verified'
                    ? isDarkTheme
                      ? 'text-grey-lighten-3'
                      : 'text-black'
                    : isDarkTheme
                    ? 'text-black'
                    : 'text-grey-lighten-6',
                ]"
                :color="
                  item.verified == 'verified' ? 'rgba(165, 216, 103, .32)' : ''
                "
                variant="flat"
              >
                {{ $helpers.uppercase(item.type) }}
              </v-chip>
            </template>

            <template #[`item.status`]="{ item }">
              <v-chip
                :class="
                  item.status === 'published'
                    ? isDarkTheme
                      ? 'text-grey-lighten-3'
                      : 'text-black'
                    : isDarkTheme
                    ? 'text-black'
                    : 'text-grey-lighten-6'
                "
                :color="
                  item.status == 'published' ? 'rgba(165, 216, 103, .32)' : ''
                "
                variant="flat"
              >
                {{ $helpers.capitalize(item.status) }}
              </v-chip>
            </template>

            <template v-if="isAuthenticated" #[`item.actions`]="{ item }">
              <div class="action-icons">
                <v-menu
                  v-if="
                    item.cid == churchid ||
                    checkAuthorization(['superAdmin']).length > 0
                  "
                  location="top"
                >
                  <template #activator="{ props }">
                    <v-icon v-bind="props" class="mr-6"> eye </v-icon>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="lang in getAvailableLanguages(item)"
                      :key="lang.code"
                      @click="previewWeekInLanguage(item, lang.code)"
                    >
                      <template #prepend>
                        <v-chip
                          size="x-small"
                          :color="getLanguageColor(lang.code)"
                          variant="outlined"
                          class="mr-2"
                        >
                          {{ lang.code.toUpperCase() }}
                        </v-chip>
                      </template>
                      <v-list-item-title>{{ lang.name }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="getAvailableLanguages(item).length === 0"
                      disabled
                    >
                      <v-list-item-title
                        >No content available</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-icon
                  v-if="
                    !isHelpDesk() &&
                    (item.cid == churchid ||
                      checkAuthorization(['superAdmin']).length > 0)
                  "
                  @click.native="loadWeekToEdit(item)"
                  class="mr-6"
                  >edit</v-icon
                >
                <v-icon
                  v-if="
                    (item.cid == churchid ||
                      checkAuthorization(['superAdmin']).length > 0) &&
                    !isHelpDesk()
                  "
                  @click.native="deleteItem(item, 'weeks')"
                  >delete_icon</v-icon
                >
              </div>
            </template>
          </v-data-table>
        </div>
      </v-flex>
      <v-snackbar
        v-model="snackbar"
        color="#592892"
        :timeout="timeout"
        location="top"
        class=""
      >
        <span v-html="snackbarMsg"></span>

        <template #actions="{ attrs }">
          <v-btn
            variant="text"
            v-bind="attrs"
            @click="snackbar = false"
            class="font-weight-bold"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
  import db from '@/firebase/init'
  import HowToUseThisPage from '@/components/utilities/HowToUseThisPage'
  import NewWeek from '@/components/utilities/NewWeek'
  import EditWeek from '@/components/utilities/EditWeek'
  import { mapGetters } from 'vuex'
  import { confirmAction } from '@/components/utilities/SwalService'
  import BookMark from '@/assets/icons/BookMark.vue'
  import { currentTheme } from '@/plugins/vuetify'
  import { getWeekTitle } from '@/helpers/weekTitle'
  import { openPreview } from '@/helpers/previewBridge'
  import { matchesConfirmWord } from '@/helpers/confirmWord'

  export default {
    name: 'Units',
    components: {
      HowToUseThisPage,
      NewWeek,
      EditWeek,
      BookMark,
    },
    data() {
      return {
        snackbar: false,
        snackbarMsg: '',
        feedback: null,
        weeks: [],
        sections: [],
        courses: [],
        allCategories: [],
        openWeeksForm: false,
        editingWeek: false,
        isEditingUnit: false,
        timeout: 6000,
        isloading: true,
        weekToEdit: null,
        weekbackdoor: 0,
        thePreviewWeek: [],
        prevType: '',
        prevStatus: '',
      }
    },
    computed: {
      churchid() {
        return this.$store.getters['AppData/cid']
      },
      ...mapGetters('UserData', ['isAuthenticated']),
      iconColor() {
        return currentTheme.value === 'dark' ? '#cecece' : '#383935'
      },
      isDarkTheme() {
        return currentTheme.value === 'dark'
      },
      adminActions() {
        let h = [
          {
            title: this.$t('weeks.tableHeaders.week'),
            sortable: true,
            key: 'title',
          },
          {
            title: this.$t('weeks.tableHeaders.cid'),
            sortable: true,
            key: 'cid',
          },
          {
            title: this.$t('weeks.tableHeaders.type'),
            sortable: true,
            key: 'type',
          },
          {
            title: this.$t('weeks.tableHeaders.status'),
            sortable: true,
            key: 'status',
          },
          { title: '#Missions', sortable: false, key: 'sections' },
          {
            title: this.$t('weeks.tableHeaders.actions'),
            sortable: false,
            key: 'actions',
            align: 'end',
          },
        ]
        if (this.isAuthenticated) {
          if (this.checkAuthorization(['admin']).length > 0)
            h = [
              { title: 'M/S UNIT', sortable: true, key: 'title' },
              { title: 'Type', sortable: true, key: 'type' },
              { title: 'Status', sortable: true, key: 'status' },
              { title: '#Missions', sortable: false, key: 'sections' },
              {
                title: 'Actions',
                sortable: false,
                key: 'actions',
                align: 'end',
              },
            ]
        }
        return h
      },
    },
    watch: {
      churchid: {
        deep: true,
        handler(event) {
          this.getWeeks(event)
        },
      },
    },
    methods: {
      getWeekTitle,
      addNewHandler() {
        localStorage.removeItem('missionStudyQuestions')
        localStorage.removeItem('supplicationStudyQuestions')
        localStorage.removeItem('supplicationVerseQuotes')

        this.weekToEdit = ''

        if (this.editingWeek) {
          if (this.$refs.addeditweekform) this.$refs.addeditweekform.reset()
          this.openWeeksForm = true
        } else {
          this.openWeeksForm = !this.openWeeksForm
        }
        this.editingWeek = false
      },
      checkAuthorization(permissions) {
        const userRoles = this.$store.getters['UserData/getRoles']
        if (permissions && userRoles) {
          const normalizedPermissions = permissions.includes('superAdmin')
            ? [...permissions, 'helpDesk']
            : permissions

          const hasRole = normalizedPermissions.filter(() =>
            userRoles.some((role) => normalizedPermissions.includes(role))
          )
          return hasRole
        }
      },
      isHelpDesk() {
        const userRoles = this.$store.getters['UserData/getRoles']
        return Array.isArray(userRoles) && userRoles.includes('helpDesk')
      },
      closebuilder() {
        this.weekToEdit = ''
        this.editingWeek = false
        this.openWeeksForm = false
      },
      closeWeeksFormChild(value) {
        // used to close the New Unit form after a successful save
        this.openWeeksForm = !value.closeWeeksForm
        this.snackbar = true
        this.timeout = 4000
        this.snackbarMsg =
          'Unit <strong><i>' +
          value.title +
          '</i></strong> has been successfully created'
        this.getWeeks(this.churchid)
      },
      closeEditWeeksFormChild(value) {
        this.editingWeek = !value.closeEditWeeksForm
        this.snackbar = true
        this.timeout = 4000
        this.snackbarMsg =
          'Week <strong><i>' +
          value.title +
          '</i></strong> has been successfully edited'
        this.getWeeks(this.churchid)
      },
      async deleteItem(item, collection) {
        if (this.isHelpDesk && this.isHelpDesk()) {
          const key = 'weeks.messages.deleteNotAllowed'
          this.feedback =
            (this.$te && this.$te(key) ? this.$t(key) : null) ||
            'Help Desk users cannot delete weeks.'
          return
        }

        if (!item || !collection) {
          return confirmAction({
            title: 'Houston we have a problem.',
            html: 'Error with the delete function, missing params.',
            confirmButtonText: 'OK',
            context: this,
          })
        }

        const title =
          collection === 'weeks' ? getWeekTitle(item) : 'this item'

        const confirmed = await confirmAction({
          title: `You are about to delete: <br>"${title}"`,
          html: 'type DELETE below to confirm.',
          input: 'text',
          inputPlaceholder: 'Type DELETE',
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (matchesConfirmWord(value, 'DELETE')) {
                resolve()
              } else {
                resolve('You need to type DELETE to confirm')
              }
            })
          },
          confirmButtonText: 'Yes Delete it!',
          cancelButtonText: 'No, Keep it!',
          context: this,
          buttonsStyling: false,
          customClass: {
            confirmButton:
              'swal-confirm-btn text-white text-uppercase text-body-2',
            cancelButton:
              'swal-cancel-btn text-white text-uppercase text-body-2',
          },
        })

        if (!confirmed) return

        try {
          await db.collection(collection).doc(item.id).delete()

          this.openWeeksForm = false
          this.editingWeek = false

          this.snackbarMsg = `Week <strong><i>${title}</i></strong> has been deleted.`
          this.snackbar = true
          this.timeout = 3000

          this.getWeeks(this.churchid)
        } catch (error) {
          console.error('Error deleting week:', error)
        }
      },
      inputHandler(week, key) {
        // console.log('inputHandler ', this.weekToEdit)
        if (this.editingWeek) {
          this.onTextChange(week, key)
        }
      },
      loadWeekToEdit(week) {
        // console.log('u ', week)
        this.weekbackdoor++
        this.openWeeksForm = false
        this.weekToEdit = week
        this.editingWeek = true
        this.prevType = week.type
        this.prevStatus = week.status

        localStorage.removeItem('missionStudyQuestions')
        localStorage.removeItem('supplicationStudyQuestions')
        localStorage.removeItem('supplicationVerseQuotes')

        if (week.missionStudyQuestions && week.missionStudyQuestions.length > 0)
          localStorage.setItem(
            'missionStudyQuestions',
            JSON.stringify(week.missionStudyQuestions)
          )

        if (
          week.supplicationStudyQuestions &&
          week.supplicationStudyQuestions.length > 0
        )
          localStorage.setItem(
            'supplicationStudyQuestions',
            JSON.stringify(week.supplicationStudyQuestions)
          )

        if (
          week.supplicationVerseQuotes &&
          week.supplicationVerseQuotes.length > 0
        )
          localStorage.setItem(
            'supplicationVerseQuotes',
            JSON.stringify(week.supplicationVerseQuotes)
          )

        this.snackbar = true
        this.timeout = 2000
        this.snackbarMsg =
          'You are currenlty editing week: <strong><i>' +
          getWeekTitle(week) +
          '</i></strong>'

        this.scrollToTop()
      },
      getAvailableLanguages(item) {
        // Get all languages that have content for this week
        const availableLanguages = []
        const supportedLanguages = [
          { code: 'en', name: 'English' },
          { code: 'pt', name: 'Português' },
          { code: 'es', name: 'Español' },
          { code: 'fr', name: 'Français' },
          { code: 'de', name: 'Deutsch' },
          // Add more languages as needed
        ]

        supportedLanguages.forEach((lang) => {
          if (this.hasLocalizedContent(item, lang.code)) {
            availableLanguages.push(lang)
          }
        })

        return availableLanguages
      },
      hasLocalizedContent(item, languageCode) {
        // Check if the week has content for the specified language
        if (item.localizedContent && item.localizedContent[languageCode]) {
          const content = item.localizedContent[languageCode]
          // Check if there's any meaningful content
          return (
            (content.title && content.title.trim()) ||
            (content.subtitle && content.subtitle.trim()) ||
            (content.missionBodyContent && content.missionBodyContent.trim()) ||
            (content.supplicationBodyContent &&
              content.supplicationBodyContent.trim()) ||
            (content.supplicationStudyQuestions &&
              content.supplicationStudyQuestions.length > 0) ||
            (content.missionStudyQuestions &&
              content.missionStudyQuestions.length > 0) ||
            (content.supplicationVerseQuotes &&
              content.supplicationVerseQuotes.length > 0)
          )
        }
        // Also check for legacy structure (week.pt.* or week.title)
        if (languageCode === 'en') {
          return item.title && item.title.trim()
        }
        if (languageCode === 'pt' && item.pt) {
          return item.pt.title && item.pt.title.trim()
        }
        return false
      },
      getLanguageColor(languageCode) {
        // Predefined colors for common languages (for consistency)
        const predefinedColors = {
          en: 'blue',
          pt: 'green',
          es: 'orange',
          fr: 'purple',
          de: 'red',
        }
        return predefinedColors[languageCode] || 'grey'
      },
      previewWeekInLanguage(week, languageCode) {
        openPreview(this.$router, this.$route, {
          name: 'PreviewWeek',
          id: week.id,
          lang: languageCode,
        })
      },
      previewWeek(week) {
        // Keep original method for backwards compatibility
        this.previewWeekInLanguage(week, 'en')
      },
      save(item) {
        // console.log('save ',item)
        const statusIndicator = document.querySelectorAll(
          '.snippet-autosave-status, .quillWrapper'
        )

        // Lets debouce this
        if (this.timeout) clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
          // your action
          db.collection('weeks')
            .doc(item.id)
            .update({
              title: item.title,
              subtitle: item.subtitle,
            })
            .then(() => {
              // set time out is only used for user experience
              // setTimeout(() => {
              statusIndicator.forEach(function (item) {
                item.classList.remove('busy')
              })
              // }, 300);
            })
            .catch((err) => {
              console.log(err)
            })
        }, 300)
      },
      missionsUsingThisWeek(item) {
        if (this.missions !== undefined)
          return this.missions.filter((mission) =>
            mission.weeks.find((week) => week.id == item.id)
          ).length
      },
      scrollToTop() {
        document.getElementById('weeks').scrollIntoView({ behavior: 'smooth' })
      },
      togglePanel(index) {
        if (this.openedPanel == index) {
          this.openedPanel = null
        } else {
          this.openedPanel = index
        }
      },
      init() {
        this.isloading = true
        this.openWeeksForm = false
        this.editingWeek = false

        // we set a timeout for the User experience
        setTimeout(() => {
          this.missions = []
          let missionsRef = db.collection('missions')
          missionsRef
            .get()
            .then((snapshot) => {
              snapshot.forEach((doc) => {
                let mission = doc.data()
                mission.id = doc.id
                this.missions.push(mission)
              })
            })
            .then(() => {
              this.allCategories = []
              let catRef = db.collection('categories')
              catRef.get().then((snapshot) => {
                snapshot.forEach((doc) => {
                  let cat = doc.data()
                  cat.id = doc.id
                  this.allCategories.push(cat)
                })
              })
            })
            .then(() => {
              this.isloading = false
            })
        }, 1000)
      },
      getWeeks(cid) {
        // console.log('getWeeks ', cid)
        // let weeksRef = db.collection('weeks')
        // weeksRef.onSnapshot(snapshot => {
        let weeksRef = db.collection('weeks')
        weeksRef.get().then((snapshot) => {
          this.weeks = []
          snapshot.forEach((snap) => {
            let week = snap.data()
            week.id = snap.id
            // this.weeks.push(week)
            // this.weeks.sort((a, b) => (a.order > b.order) ? 1 : -1)

            if (cid === null || cid === undefined) {
              if (
                this.isAuthenticated &&
                this.checkAuthorization(['superAdmin']).length > 0
              )
                this.weeks.push(week)
            } else {
              if (
                (this.isAuthenticated &&
                  this.checkAuthorization(['superAdmin']).length > 0 &&
                  !week.cid) ||
                (week.cid && week.cid == cid)
              ) {
                this.weeks.push(week)
                this.weeks.sort((a) => {
                  if (a.cid) return -1
                  return 0
                })
              }
            }

            if (
              this.isAuthenticated &&
              !this.checkAuthorization(['superAdmin']).length > 0
            ) {
              this.weeks.sort((a) => {
                if (a.cid) return -1
                return 0
              })
            }
          })

          this.init()
        })
      },
    },
    created() {
      this.getWeeks(this.$store.getters['AppData/cid'])
    },
  }
</script>

<style>
  .weeks-container {
    margin-top: 50px;
    margin-bottom: 25%;
  }
  .weeks-container trix-editor {
    background: #fff;
  }
  .weeks-container .weeks-icon {
    margin-right: 10px;
  }
  .weeks-container .builder-title {
    font-size: 32px;
  }
  .weeks-container .v-expansion-panels {
    justify-content: flex-start;
  }
  .weeks-container .v-expansion-panel > div {
    width: 100%;
  }
  .weeks-container .v-expansion-panel__header {
    cursor: grab;
  }
  .weeks-container .v-expansion-panel {
    border: none;
  }
</style>
